import React from "react"
import CustomPayIcon from "./custom-pay-icon-svg"

const NewProduct = ({onClick}) =>
  <a className="shop-new-product" onClick={onClick}>
    <span className="fa fa-plus"/>
  </a>

const ProductIcon = props =>
  <div className="shop-product" onClick={props.onClick}>
    <div className="shop-product__image">
      <span className={`fa fa-${props.icon}`}/>
    </div>
    <div className="shop-product__title">{props.title}</div>
  </div>

const ReservationProduct = props =>
  <div className="shop-product" >
    <div className="shop-product__image" onClick={props.onClick} >
      <img src="/images/shop-reservation-icon.png"/>
    </div>
    <div className="shop-product__title" onClick={props.onClick} >Reservation</div>
  </div>

const ProductTrash = ({refFunc}) =>
  <div id='productTrash' className='shop-product-trash shop-product' data-id='0' ref={refFunc}>
    <span className="fa fa-trash"/>
  </div>

const UncategorizedProduct = props =>
  <div className="shop-product" onClick={props.onClick}>
    <div className="shop-product__image">
      <CustomPayIcon color={`#4E7EED`} />
    </div>
    <div className="shop-product__title">{props.title}</div>
  </div>

export {NewProduct, ProductIcon, ProductTrash, ReservationProduct, UncategorizedProduct}
